import { z } from 'zod';
import { bulkCreateLocationTypes } from 'wasp/client/operations';
import type { CsvEntityConfig } from '../types';

const validationSchema = z.object({
  key: z.string().min(1, 'Key is required'),
  label: z.string().min(1, 'Label is required'),
  description: z.string().optional().default(''),
  icon: z.string().optional().default(''),
  isActive: z.string().optional().default('true'),
});

export const locationTypeConfig: CsvEntityConfig = {
  entityName: 'Location Types',
  entityNameSingular: 'Location Type',
  columns: [
    { key: 'key', label: 'Key', required: true, description: 'Unique identifier (lowercase, no spaces)', exampleValue: 'apartment_building' },
    { key: 'label', label: 'Label', required: true, description: 'Display name', exampleValue: 'Apartment Building' },
    { key: 'description', label: 'Description', required: false, description: 'Optional description', exampleValue: 'Multi-unit residential building' },
    { key: 'icon', label: 'Icon', required: false, description: 'Lucide icon name', exampleValue: 'Building' },
    { key: 'isActive', label: 'Is Active', required: false, description: 'true/false (default: true)', exampleValue: 'true' },
  ],
  validationSchema,
  exampleRows: [
    { key: 'apartment_building', label: 'Apartment Building', description: 'Multi-unit residential building', icon: 'Building', isActive: 'true' },
    { key: 'community_center', label: 'Community Center', description: 'Local community gathering space', icon: 'Home', isActive: 'true' },
  ],
  bulkCreateAction: bulkCreateLocationTypes as any,
};



